import { handleActions } from 'redux-actions';
import {
  exchangeAzureSsoToken,
  getSelf,
  loginUser,
} from 'store/auth/actions';
import { setTokensFromStorage, signOut } from 'store/auth/authActions';
import { createSimpleHandler } from 'store/utils/createSimpleHandler';
import {
  getAuthTokens,
  resetAuthTokens,
  setAuthTokens,
  UserTokens,
} from 'utilities/authTokens';

export type User = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  mobileNumber: string;
  termsAccepted: boolean;
  paymentAccountData?: null;
  password?: string;
  zipCode: string;
  zendeskUserId: number;
  address?: string;
  marketingSourceId?: number;
  marketingName?: string;
  isFleet?: boolean;
  permission: string[];
  authGroups: string[];
  enabled?: boolean;
};

export interface IAuthStoreState {
  tokens?: UserTokens;
  userRegistration?: any;
  user?: User;
}

const defaultState: IAuthStoreState = {
  tokens: getAuthTokens(),
  userRegistration: undefined,
  user: undefined,
};

const reducer = handleActions<IAuthStoreState, any>(
  {
    [loginUser.typeAPISuccess]: (state, action: { payload: UserTokens }) => {
      setAuthTokens(action);
      return { ...state, tokens: action.payload };
    },

    [exchangeAzureSsoToken.typeAPISuccess]: (
      state,
      action: { payload: UserTokens }
    ) => {
      setAuthTokens(action);
      return { ...state, tokens: action.payload };
    },

    [setTokensFromStorage.type]: createSimpleHandler('tokens'),

    /**
     * GET /isp-service/admin/users/self response.
     * Stores the full user object including permission, authGroups, enabled.
     */
    [getSelf.typeAPISuccess]: (state, action: { payload: any }) => {
      const { permission, authGroups, enabled, ...rest } = action.payload;
      return {
        ...state,
        user: {
          ...rest,
          permission: permission ?? [],
          authGroups: authGroups ?? [],
          enabled: enabled ?? true,
        },
      };
    },

    [signOut.type]: () => {
      resetAuthTokens();
      return { ...defaultState, tokens: undefined };
    },
  },
  defaultState
);

export default reducer;
